import { SxProps, Theme, Typography, TypographyOwnProps } from "@mui/material";
import {
	FONT_COLOR_DESCRIPTION,
	FONT_FAMILY,
	FONT_SIZE,
	FONT_WEIGHT_REGULAR,
	TEXT_ALIGN,
} from "../global-config/BaseConfig";

/**
 * Default Styling
 */
const sxCoreBody: SxProps<Theme> = {
	color: FONT_COLOR_DESCRIPTION,

	fontSize: FONT_SIZE,
	fontWeight: FONT_WEIGHT_REGULAR,
	fontFamily: FONT_FAMILY,

	textAlign: TEXT_ALIGN,
};

/**
 * Define props and a handler for common use cases (sx)
 */
type SxOverrides = {
	ellipsis?: boolean;
};

const SxOverrideHandler = (sxDefault: SxProps<Theme>, sxOverrides?: SxOverrides) => {
	if (!sxOverrides) {
		return sxDefault;
	}

	let sx = { ...sxDefault };

	sx = sxOverrides?.ellipsis ? { ...sx, textOverflow: "ellipsis", textWrap: "nowrap", overflow: "hidden" } : sx;

	return sx;
};

/**
 * Additional props for functions internal logic
 */
type InternalLogic = {
	dummyLogic?: boolean;
};

/**
 * Type for all the props in the main component
 */
type CoreBodyProps = TypographyOwnProps & SxOverrides & InternalLogic;

/**
 * Default styled container to display text content
 */
export const CoreBody = (props: CoreBodyProps) => {
	/* Apply overrides if existent */
	const { ellipsis, children, sx, ...rest } = props;
	const sxDefault: SxProps<Theme> = SxOverrideHandler(sxCoreBody, { ellipsis });

	return (
		<Typography sx={{ ...sxDefault, ...sx }} {...rest}>
			{children}
		</Typography>
	);
};
